import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from "react";
import RouterWrapper from './auth';



//NO AUTH
import Login from '../Views/Login';
import RecuperarSenha from '../Views/RecuperacaoSenha'
import Page404 from '../Views/404'
import TrocaEmail from '../Views/TrocaEmail'
import Autenticar from '../Views/AutenticarEmail'


//AUTH
import Dashboard from '../Views/Dashboard';
import Perfil from '../Views/Perfil'



import Usuarios from '../Views/Cadastros/Usuarios'

import Tecnico from '../Views/Tecnico'
import Logs from '../Views/Tecnico/Logs'
import Requests from '../Views/Tecnico/Requests'


import Equipamento from '../Views/Cadastros/Estrutura/Equipamento'
import EquipamentoFormato from '../Views/Cadastros/Estrutura/EquipamentoFormato'
import Marca from '../Views/Cadastros/Marca'
import Cadastros from '../Views/Cadastros'

import Proprietario from '../Views/Proprietario'
import Fornecedores from '../Views/Cadastros/Fornecedores'
import CamposPersonalizados from '../Views/Cadastros/CamposPersonalizados'

import Clientes from '../Views/Cadastros/Clientes'
import Cliente from '../Views/Cadastros/Clientes/Cliente'
import MovimentacoesCliente from '../Views/Cadastros/Clientes/MovimentacaoCliente'

import Produtos from '../Views/Produtos'
import Movimentacoes from '../Views/Movimentacoes'
import MovimentacoesProduto from '../Views/Produtos/Movimentacao'


const Router = () => {

    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])


    const RouterTecnico = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Tecnico} isPrivate={false} />} />
                <Route path="/logs" element={<RouterWrapper component={Logs} isPrivate={false} />} />
                <Route path="/requests" element={<RouterWrapper component={Requests} isPrivate={false} />} />
            </Routes>
        )
    }


    const RouterCliente = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Clientes} isPrivate={false} />} />
                <Route path="/cliente/:id" element={<RouterWrapper component={Cliente} isPrivate={false} />} />
                <Route path="/movimentacoes/:id" element={<RouterWrapper component={MovimentacoesCliente} isPrivate={false} />} />
            </Routes>
        )

    }

    const RouterProduto = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Produtos} isPrivate={false} />} />
                <Route path="/produto-cronologia/:id" element={<RouterWrapper component={MovimentacoesProduto} isPrivate={false} />} />
            </Routes>
        )
    }

    const RouterCadastro = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Cadastros} isPrivate={false} />} />
                <Route path="/clientes/*" element={<RouterWrapper component={RouterCliente} isPrivate={false} />} />
                <Route path="/fornecedores" element={<RouterWrapper component={Fornecedores} isPrivate={false} />} />
                <Route path="/equipamento" element={<RouterWrapper component={Equipamento} isPrivate={false} />} />
                <Route path="/equipamentoFormato/:id" element={<RouterWrapper component={EquipamentoFormato} isPrivate={false} />} />
                <Route path="/marca" element={<RouterWrapper component={Marca} isPrivate={false} />} />
                <Route path="/usuarios" element={<RouterWrapper component={Usuarios} isPrivate={false} />} />
                <Route path="/campos-personalizados" element={<RouterWrapper component={CamposPersonalizados} isPrivate={false} />} />
            </Routes>
        )

    }



    return (
        <Routes>
            <Route path="/dashboard" element={<RouterWrapper component={Dashboard} isPrivate={true} />} />
            <Route path="/cadastros/*" element={<RouterWrapper component={RouterCadastro} isPrivate={true} />} />
            <Route path="/proprietario" element={<RouterWrapper component={Proprietario} isPrivate={true} />} />
            <Route path="/produtos/*" element={<RouterWrapper component={RouterProduto} isPrivate={true} />} />
            <Route path="/perfil" element={<RouterWrapper component={Perfil} isPrivate={true} />} />
            <Route path="/movimentacoes" element={<RouterWrapper component={Movimentacoes} isPrivate={true} />} />
            <Route path="/tecnicoIndex/*" element={<RouterWrapper component={RouterTecnico} isPrivate={true} />} />
            <Route path="/movimentacao-cliente/:id" element={<RouterWrapper component={MovimentacoesCliente} isPrivate={true} />} />
            <Route path="/recuperarSenha/:token" element={<RouterWrapper component={RecuperarSenha} isPrivate={false} />} />
            <Route path="/trocarEmail/:token" element={<RouterWrapper component={TrocaEmail} isPrivate={false} />} />
            <Route path="/autenticarEmail/:token" element={<RouterWrapper component={Autenticar} isPrivate={false} />} />
            <Route path="/" element={<RouterWrapper component={Login} isPrivate={false} />} />
            <Route path="*" element={<Page404 />} />
        </Routes>
    )
}

export default Router